import { FacebookAuthProvider, signInWithPopup, getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { trackEvent, trackFBEvent } from "../helper/tracking/tracking";

const FirebaseWrapper = {

    facebookLogin: async() => {
        const provider = new FacebookAuthProvider();

        const auth = getAuth();
        auth.languageCode = 'de';
        provider.addScope("email");

        try {
            await signInWithPopup(auth, provider);
            trackEvent('login', { method: 'facebook' });
            trackFBEvent('CompleteRegistration');
            return true;
        } catch(err) {
            return false;
        }
    },

    googleLogin: async() => {
        const provider = new GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/userinfo.email');

        const auth = getAuth();
        auth.languageCode = 'de';

        try {
            await signInWithPopup(auth, provider);
            trackEvent('login', { method: 'google' });
            trackFBEvent('CompleteRegistration');
            return true;
        } catch(err) {
            return false;
        }

    },
    appleLogin: async() => {
        const provider = new OAuthProvider('apple.com');
        provider.addScope('email');
        provider.setCustomParameters({ locale: 'de' });

        const auth = getAuth();
        auth.languageCode = 'de';

        try {
            await signInWithPopup(auth, provider);
            trackEvent('login', { method: 'apple' });
            trackFBEvent('CompleteRegistration');
            return true;
        } catch(err) {
            return false;
        }
    }

};

export default FirebaseWrapper;
